import User, { Identity } from '@interfaces/user.interface'
import onUserChange from '@observables/user.observable'
import { ReactElement, useEffect, useMemo, useRef, useState } from 'react'
import { SubscriptionLike } from 'rxjs'
import Loader from '../loader/loader.component'
import SocialItem from '../social-item/social-item.component'
import './social-connect.component.scoped.scss'

export type SocialMediaIcon = {
  socialNetwork: string
  username?: string
  icon: ReactElement
  bgColor: string
  isEmpty?: boolean
  id?: string
}

export default () => {
  const socialMediaBox = useRef<HTMLDivElement>(null)
  const onUserChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)

  const [user, setUser] = useState<User | null>(null)

  const socialMediaIcons: SocialMediaIcon[] = useMemo(() => {
    return [
      { socialNetwork: '', icon: <i className="fa-solid fa-user gray-light" />, bgColor: 'var(--gray)', isEmpty: true },
      {
        socialNetwork: 'facebook',
        // TODO: Validação Meta remover
        icon:
          user?.profileadditionalinfo?.email === 'hfyuoiakom_1634747033@tfbnw.net' ? (
            <i className="fa-brands fa-facebook gray-light" />
          ) : (
            <i className="fa-brands fa-instagram gray-light" />
          ),
        bgColor: user?.profileadditionalinfo?.email === 'hfyuoiakom_1634747033@tfbnw.net' ? 'var(--facebook)' : 'var(--instagram)',
        isEmpty: true,
      },
      {
        socialNetwork: 'twitter',
        icon: <i className="fa-brands fa-x-twitter gray-light" />,
        bgColor: 'var(--x)',
        isEmpty: true,
      },
      {
        socialNetwork: 'youtube',
        icon: <i className="fa-brands fa-youtube gray-light" />,
        bgColor: 'var(--youtube)',
        isEmpty: true,
      },
      {
        socialNetwork: 'tiktok',
        icon: <i className="fa-brands fa-tiktok gray-light" />,
        bgColor: 'var(--tiktok)',
        isEmpty: true,
      },
    ]
  }, [user])

  const [isLoading, setIsLoading] = useState(true)
  const [socialMediaItems, setSocialMediaItems] = useState<any>(socialMediaIcons)

  useEffect(() => {
    onUserChangeSubscription.current = onUserChange.subscribe((userChanged: User) => {
      setUser(userChanged)
      setIsLoading(false)
    })

    return () => onUserChangeSubscription?.current?.unsubscribe()
  }, [])

  useEffect(() => {
    const mapProfilesToMediaIcons =
      user?.identities?.map((identity: Identity) => {
        let socialNetwork = null
        if (identity?.connection === 'instagram') {
          socialNetwork = 'facebook'
        } else if (identity?.connection === 'google-oauth2') {
          socialNetwork = 'youtube'
        } else {
          socialNetwork = identity?.connection
        }
        return {
          socialNetwork,
          username: identity?.username,
          id: identity?.user_id,
          icon: (
            <figure style={{ width: '100%', height: '100%' }}>
              <img src={identity?.picture} alt="icon" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />
            </figure>
          ),
          bgColor: 'var(--gray)',
        }
      }) || []
    const linkedSocialNetworks = mapProfilesToMediaIcons?.map(({ socialNetwork }: any) => socialNetwork)
    const optionsToVinculate = socialMediaIcons?.filter(({ socialNetwork }) => !linkedSocialNetworks.includes(socialNetwork))
    setSocialMediaItems([...optionsToVinculate, ...mapProfilesToMediaIcons])
  }, [user, socialMediaIcons])

  if (isLoading) {
    return (
      <div className="text-center py-3" style={{ width: '100%' }}>
        <Loader size="small" />
      </div>
    )
  }

  return (
    <div className="social-connect" ref={socialMediaBox}>
      {socialMediaItems?.map((item: SocialMediaIcon, i: number) => (
        <SocialItem key={i} item={item} />
      ))}
    </div>
  )
}
